import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Cart} from './model';

export interface CartState extends EntityState<Cart> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Cart' })
export class Store extends EntityStore<CartState> {

  constructor() {
    super();
  }

}
